import { Outlet } from "react-router-dom";

// material-ui
import Grid from "@mui/material/Grid";

// ==============================|| MINIMAL LAYOUT ||============================== //

// third-party
import { FormattedMessage } from "react-intl";

// project imports
import LoadingModal from "ui-component/LoadingModal";
import TopBar from "ui-component/TopBar";

// assets
import GLOBAL_BG from "assets/images/bg-pc.png";

const MinimalLayout = () => {
  return (
    <Grid container direction={"column"} alignItems={"center"}>
      <Grid
        sx={{
          width: "100vw",
          height: "100vh",
          position: "fixed",
          background: { xs: `none`, sm: `no-repeat center/100% 100% url(${GLOBAL_BG})` }
        }}
      />

      <Grid item container direction={"column"} width={{ xs: "100%", sm: "875px" }} zIndex={10}>
        <TopBar title={<FormattedMessage id={"KOA_SIMULATOR"} />} />
        <Outlet />
      </Grid>

      <LoadingModal />
    </Grid>
  );
};

export default MinimalLayout;
